/** True when the end clock time falls on the calendar day after the start (e.g. 22:00–04:00). */
export const isOvernightProgramTimeRange = (startTime: string, endTime: string): boolean =>
  endTime <= startTime;

/** Zero-duration ranges are invalid; overnight spans are allowed. */
export const isProgramTimeRangeInvalid = (startTime: string, endTime: string): boolean =>
  Boolean(startTime && endTime && startTime === endTime);

export const programTimeRangeLabel = (
  startTime: string,
  endTime: string,
  t: (key: 'timeRange' | 'timeRangeOvernight', params: { start: string; end: string }) => string,
): string =>
  isOvernightProgramTimeRange(startTime, endTime)
    ? t('timeRangeOvernight', { start: startTime, end: endTime })
    : t('timeRange', { start: startTime, end: endTime });
